import { Crop } from 'react-image-crop'
import { FileType } from '@citruscamps/citrus-client'

interface IProps {
  ref: React.RefObject<HTMLImageElement | null>
  crop: Crop
  filename: string
  filetype?: FileType
  circularCrop?: boolean
}

export const cropImage = async ({
  ref,
  crop,
  filename,
  filetype = 'image/jpeg',
  circularCrop,
}: IProps): Promise<File> => {
  if (!ref.current) throw new Error('Failed to crop image')
  const canvas: HTMLCanvasElement = document.createElement('canvas')

  const scaleX = ref.current.naturalWidth / ref.current.width
  const scaleY = ref.current.naturalHeight / ref.current.height
  crop.x = crop.x || 1
  crop.y = crop.y || 1
  if (crop.width && crop.height) {
    canvas.width = Math.round(crop.width * scaleX)
    canvas.height = Math.round(crop.height * scaleY)
  }

  const ctx = canvas.getContext('2d')

  if (ctx && crop.x && crop.y && crop.width && crop.height) {
    ctx.imageSmoothingQuality = 'high'
    ctx.drawImage(
      ref.current,
      Math.round(crop.x * scaleX),
      Math.round(crop.y * scaleY),
      Math.round(crop.width * scaleX),
      Math.round(crop.height * scaleY),
      0,
      0,
      Math.round(crop.width * scaleX),
      Math.round(crop.height * scaleY),
    )
    if (circularCrop) {
      ctx.globalCompositeOperation = 'destination-in'
      ctx.beginPath()
      ctx.arc(
        (crop.width * scaleX) / 2,
        (crop.height * scaleY) / 2,
        (crop.width * scaleX) / 2,
        0,
        2 * Math.PI,
        false,
      )
      ctx.closePath()
      ctx.fill()
    }
  }
  try {
    const promise = new Promise<Blob | null>((resolve) => {
      canvas.toBlob(resolve, filetype)
    })
    const blob: Blob | null = await promise
    if (blob) {
      return new File([blob], filename, { type: blob.type })
    } else {
      throw new Error('Failed to create new image')
    }
  } catch (e: any) {
    throw e
  }
}
